/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useEffect, useState } from "react";

// @mui material components
import Icon from "@mui/material/Icon";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { styled } from "@mui/system";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Settings page components
import DashboardLayout from "LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Skill90DashboardNavbar";
import DataTable from "Tables/DataTableMultiline";
import AdvancedSettlementFilters from "./components/Filters";
import SoftSelect from "components/SoftSelect";
// react-select components

// import BasicInfo from "./components/BasicInfo";
// import ChangePassword from "./components/ChangePassword";
// import DeleteAccount from "./components/DeleteAccount";

// react-router components
import { useLocation, useSearchParams } from "react-router-dom";

import { getData, postData } from "Utils/server";
import { getAuthorizationHeader, getUserData } from "Utils/helpers";
import { useSoftUIController } from "context";

// sweetalert2 components
import Swal from "sweetalert2";

import DialogBox from "Modals/CheckLeavePage";
import { useCallbackPrompt } from "hooks/useCallbackPrompt";


/**
 *
 */
const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    //backgroundColor: "#f5f5f9",
    backgroundColor: "#000",
    color: "rgba(f, f, f, 1)", //"rgba(0, 0, 0, 0.87)",
    placement: "left",
    maxWidth: 500,
    minWidth: "minContent",
    height: "minContent",
    textAlign: "left",
    fontSize: "0.65erm",
    border: "1px solid #dadde9",
    boxShadow: "0rem 1.25rem 1.6875rem 0rem rgba(0, 0, 0, 0.05)",
    padding: "15px",
    marginLeft: "15px",
  },
}));

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="outlined" {...props} />;
});

let settlementOutcomes = [];
let settlements = [];
let originalData = [];
let currentData = [];
let availableProviders = [];

function AdvancedRisks() {
  const userData = getUserData();
  const [controller, dispatch] = useSoftUIController();

  const { providers } = controller;

  const [updateEnabled, setUpdateEnabled] = useState(false);
  const [filterToggle, setFilterToggle] = useState(true);
  const [loadingData, setLoadingData] = useState(false);
  const [applyFilters, setApplyFilters] = useState(false);
  const [displayData, setDisplayData] = useState(false);
  const [preloadFilters, setPreloadFilters] = useState(null);

  const [notification, setNotification] = useState(false);
  const [apiResponse, setApiresponse] = useState("success");
  const [apiResponseMsg, setApiResponseMsg] = useState("success");
  const [modeChanges, setModeChanges] = useState(false);

  const [showDialog, setShowDialog] = useState(false);
  const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(showDialog);
  const [externalSearch, setExternalSearch] = useState(null);
  const [loading, setLoading] = useState(false);

  const [riskRuleSelected, setRiskRuleSelected] = useState(5);

    const riskRules = {
    1: { ico: "receipt_long_outlined_icon", info: "Closing Winning Betslip" },
    2: { ico: "access_time_outlined_icon", info: "Very Fast Settlement" },
    3: { ico: "person_off_outlined_icon", info: "User Ban" },
    4: { ico: "favorite_norder_outlined_icon", info: "Check Later" },
  };

  //const [availableProviders, setAvailableProviders] = useState([]);

  const [settlementOrigins, setSettlementOrigins] = useState([
    { value: 1, label: "Live Settlement" },
    { value: 3, label: "Operator" },
    { value: 2, label: "Statistics Settlement" },
  ]);

  const [dataTableData, setDataTableData] = useState({
    columns: [
      { Header: "tm", accessor: "tm", width: "100px" },
      { Header: "", accessor: "openSwitch", width: "100px" },
      { Header: "Betslip ID", accessor: "bet_id", width: "100px", Cell: renderBetId },
      { Header: "Type", accessor: "betslip_type", width: "100px" },
      { Header: "Pre/InPlay", accessor: "betslip_eventsType", width: "100px" },
      { Header: "Risk", accessor: "risks", width: "100px", Cell: renderRisks },
      {
        Header: "Placed At",
        accessor: "b_created_at",
        width: "100px",
        Cell: formatDateStringUTCtoLocale,
      },
      { Header: "Platform", accessor: "name", width: "100px" },
      { Header: "Currency", accessor: "code", width: "100px" },
      { Header: "Multiplier", accessor: "odds_multiplier", width: "100px" },
      { Header: "Stake", accessor: "amount", width: "100px" },
      { Header: "Possible Return", accessor: "inreturn", width: "100px" },
      { Header: "Status", accessor: "betslip_status", width: "100px", Cell: renderBetslipStatus },
    ],

    rows: [],
  });
  const [hiddenColumns, setHiddenColumns] = useState(["tm"]);
  let [searchParams, setSearchParams] = useSearchParams();

  const { hash, pathname, search } = useLocation();

  const platforms = userData
    ? userData.platforms
      ? userData.platforms.map((platform) => ({
          value: platform.id,
          label: platform.name,
          logo: platform.logo,
          sorting: platform.sorting,
          odds_styles: platform.odds_styles,
        }))
      : []
    : [];

  function openInNewWindow(e, uri) {
    e.preventDefault();
    let url = uri;
    // console.log(window.URL);
    window.open(url.toString(), "_blank", "noreferrer");
  }

  function renderSettlementInfo({ value, ...rest }) {
    let classname = rest.row.original.risks
      ? rest.row.original.higherRisk
        ? "blocked"
        : "info"
      : "";
    if (!rest.row.original.settlement_date && !value) {
      return (
        <div>
          <div className={classname}> - </div>
          <div style={{ display: rest.row.original.risks ? "none" : "", color: "green" }}>
            {" "}
            NO Risk{" "}
          </div>
          <div style={{ display: rest.row.original.risks ? "" : "none", color: "red" }}>Risk: </div>
          <ul>
            {rest.row.original.risks &&
              rest.row.original.risks.map((r, index) => {
                return (
                  <div key={r + "-" + index} style={{ display: "flex" }}>
                    <span>{riskRules[r.rule].info} </span>
                    <div>
                      <HtmlTooltip
                        placement="right"
                        title={<React.Fragment>Blocked</React.Fragment>}
                      >
                        <Icon
                          style={{
                            display: rest.row.original.higherRisk ? "" : "none",
                            color: "red",
                            margin: "5px",
                          }}
                        >
                          block_outlined_icon
                        </Icon>
                      </HtmlTooltip>
                    </div>
                  </div>
                );
              })}
          </ul>
        </div>
      );
    }

    let date = new Date(value);
    let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
    let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();

    let dateformatted = day + "/" + month + "/" + date.getFullYear() + " " + hours + ":" + minutes;
    let timezone = (date.getTimezoneOffset() * -1) / 60;
    timezone = timezone > 0 ? "+" + timezone : timezone;
    let operator =
      rest.column.id == "settlement_date" ? rest.row.original.settled_by_operator : false;

    let betdate = rest.column.id == "created_at" ? true : false;
    let betMoment = null;
    if (betdate) {
      betMoment = "pre";
      if (date.getTime() > rest.row.original.start_date_utc * 1) betMoment = "live";
    }

    const diffTime = rest.row.original.diff;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor((diffTime - diffDays * 1000 * 60 * 60 * 24) / (1000 * 60 * 60));
    const diffMinutes = Math.floor(
      (diffTime - diffDays * 1000 * 60 * 60 * 24 - diffHours * 1000 * 60 * 60) / (1000 * 60)
    );

    let settlementType = rest.row.original.settler.split(": ")[0];
    let settler = rest.row.original.settler.split(": ")[1];

    return (
      <div className={classname}>
        <div className={betMoment ? betMoment + "-bet" : ""}>
          {dateformatted}{" "}
          <Icon style={{ display: operator ? "" : "none", color: "#17c1e8" }}>person_icon</Icon>
        </div>

        <div style={{ display: "flex" }}>
          <div>{settlementType}:</div>

          <div style={{ display: settlementType == "operator" ? "" : "none", color: "#17c1e8" }}>
            {settler ? settler : " - "}
          </div>
          <div
            style={{
              display: settler == "offline" ? "" : "none",
              color: settler == "offline" ? "black" : "green",
            }}
          >
            {settlementType == "operator" ? "" : settler}
          </div>
          <div
            style={{
              display: settler == "online" ? "" : "none",
              color: settler == "offline" ? "black" : "green",
            }}
          >
            {settler}
          </div>
        </div>
        <div>
          {" "}
          Time Diff: {diffDays < 10 ? "0" + diffDays : diffDays}:
          {diffHours < 10 ? "0" + diffHours : diffHours}:
          {diffMinutes < 10 ? "0" + diffMinutes : diffMinutes}
        </div>
        <div>
          <div style={{ display: rest.row.original.risks ? "none" : "", color: "green" }}>
            {" "}
            NO Risk{" "}
          </div>
          <div style={{ display: rest.row.original.risks ? "" : "none", color: "red" }}>Risk: </div>
          <ul>
            {rest.row.original.risks &&
              rest.row.original.risks.map((r, index) => {
                return (
                  <div key={r + "-" + index} style={{ display: "flex" }}>
                    <span>{riskRules[r.rule].info} </span>
                    <div>
                      <HtmlTooltip
                        placement="right"
                        title={<React.Fragment>Blocked</React.Fragment>}
                      >
                        <Icon
                          style={{
                            display: rest.row.original.higherRisk ? "" : "none",
                            color: "red",
                            margin: "5px",
                          }}
                        >
                          block_outlined_icon
                        </Icon>
                      </HtmlTooltip>
                    </div>
                  </div>
                );
              })}
          </ul>
        </div>
      </div>
    );
  }

  function renderBetId({ value, ...rest }) {
    return (
      <div style={{ display: "flex" }}>
        <div
          className={
            rest.row.original.betslip_status == "won"
              ? "bet-won"
              : rest.row.original.betslip_status == "lost"
              ? "bet-lost"
              : "bet-open"
          }
        >
          {value}
        </div>
        <div style={{ paddingLeft: "5px" }}>
          <HtmlTooltip
            placement="right"
            title={
              <React.Fragment>
                <div>{rest.row.original.user_id}</div>
              </React.Fragment>
            }
          >
            <Icon>account_circle_outlined_icon </Icon>
          </HtmlTooltip>
        </div>
      </div>
    );
  }

  function renderRisks({ value, ...rest }) {
    return (
      <div>
        {value
          ? Object.keys(value).map((risk, index) => {
              return (
                <div key={rest.row.original.bet_id + "-risk-" + index}>
                  <HtmlTooltip
                    placement="right"
                    title={
                      <React.Fragment>
                        <div>
                          {riskRules[risk].info} : {value[risk].status}
                        </div>
                        <div style={{ display: value[risk].note ? "" : "none" }}>
                          notes : {value[risk].note}
                        </div>
                      </React.Fragment>
                    }
                  >
                    <Icon className={`risk-rule-${risk}`}>{riskRules[risk].ico} </Icon>
                  </HtmlTooltip>
                  : <span>{value[risk].count}</span>
                </div>
              );
            })
          : ""}
      </div>
    );
  }

  function renderBetslipStatus({ value, ...rest }) {
    return (
      <div style={{ display: "flex" }}>
        <div>{value}</div>
        <div>
          <HtmlTooltip placement="right" title={<React.Fragment>Blocked</React.Fragment>}>
            <Icon
              style={{
                display: rest.row.original.higherRisk ? "" : "none",
                color: "red",
                margin: "5px",
              }}
            >
              block_outlined_icon
            </Icon>
          </HtmlTooltip>
        </div>
        <div
          style={{
            display:
              !rest.row.original.multiline ||
              !rest.row.original.multiline.rows ||
              !rest.row.original.multiline.rows.length > 0
                ? "none"
                : "",
          }}
        >
          <HtmlTooltip
            placement="right"
            title={<React.Fragment>Add/Remove to Favorites list</React.Fragment>}
          >
            <Button
              style={{
                margin: "auto",
                padding: "2px",
              }}
            >
              <Icon onClick={(e) => handleFavorite(e, rest.row.original)}>{riskRules[4].ico} </Icon>
            </Button>
          </HtmlTooltip>
          <HtmlTooltip
            placement="right"
            title={<React.Fragment>Approve Betslip Risks</React.Fragment>}
          >
            <Button
              style={{
                margin: "auto",
                padding: "2px",
              }}
            >
              <Icon onClick={(e) => approveRisks(e, rest.row.original)} color="success">
                check_outlined_icon
              </Icon>
            </Button>
          </HtmlTooltip>
          <HtmlTooltip
            placement="right"
            title={<React.Fragment>Block/Unblock Current User</React.Fragment>}
          >
            <Button
              style={{
                margin: "auto",
                padding: "2px",
              }}
            >
              <Icon onClick={(e) => handleFavorite(e, rest.row.original)} color="error">
                person_off_outlined_icon{" "}
              </Icon>
            </Button>
          </HtmlTooltip>
        </div>
      </div>
    );
  }

  function fixtureCell({ value, ...rest }) {
    value = formatDate({ value: rest.row.original.start_date_utc, ...rest });
    let statuses = formatStatuses({ value: rest.row.original.statuses, ...rest });
    let selectedFixture = rest.row.original;

    return (
      <div style={{ display: "flex" }}>
        <div style={{ width: "80px" }}>
          <div style={{ wordWrap: "auto", width: "80px" }}>{value}</div>
          <div style={{ wordWrap: "auto", width: "80px" }}>{statuses}</div>
        </div>

        <div style={{ width: "100%" }}>
          <div style={{ display: "flex", paddingBottom: "6px", width: "max-content" }}>
            <div>
              <span className="sport-breadcrumb">{rest.row.original.sport}</span>{" "}
              <span>
                <Icon>navigate_next_icon </Icon>
              </span>
            </div>
            <div>
              <span>{rest.row.original.region}</span>
              <span>
                <Icon>navigate_next_icon </Icon>
              </span>
            </div>
            <div>
              <span>{rest.row.original.competition}</span>
            </div>
          </div>
          <div>
            <div>
              <span>{rest.row.original.home}</span>
            </div>

            <div>
              <span>{rest.row.original.away}</span>
            </div>
          </div>
        </div>

        <div style={{ minWidth: "180px", display: "flex" }}>
          <div>
            <HtmlTooltip
              placement="right"
              title={
                <React.Fragment>
                  <div style={{}}>
                    <div>
                      {"UniID: "}
                      {rest.row.original.uni_id ? rest.row.original.uni_id : "-"}
                    </div>
                    {rest.row.original.providers.map((item, index) => {
                      let provider = availableProviders.find((p) => p.value === item);
                      let providerName = provider ? provider["info"] : item;
                      return (
                        <div
                          key={item + "-" + rest.row.original.fixtureIds[index]}
                          style={{ display: "flex" }}
                        >
                          <div className={"provider-" + providerName + "-inverse"}>
                            {providerName}
                          </div>
                          <div>
                            {": "} {rest.row.original.fixtureIds[index]}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </React.Fragment>
              }
            >
              <Button
                style={{
                  padding: 0,
                  padding: "0px",
                  width: "30px",
                  maxWidth: "30px",
                  minWidth: "10px",
                  marginTop: "80%",
                }}
              >
                <span style={{ paddingLeft: "5px" }}> </span>
                <Icon>info_outlined </Icon>
              </Button>
            </HtmlTooltip>
          </div>
          <div style={{ borderLeft: "1px solid #cecece" }}>
            <SoftBox style={{ marginLeft: "auto" }}>
              <Button
                className="betfoot-button"
                style={{
                  display: selectedFixture
                    ? selectedFixture.providers.findIndex((item) => item == 3) > -1
                      ? ""
                      : "none"
                    : "none",
                }}
                disabled={!selectedFixture}
                onClick={(e) =>
                  searchBetfoot(
                    e,
                    selectedFixture
                      ? selectedFixture.fixtureIds[
                          selectedFixture.providers.findIndex((item) => item == 3)
                        ]
                      : null,
                    selectedFixture ? selectedFixture.sport.replace(/ /g, "-").toLowerCase() : null
                  )
                }
              >
                1xbet Results
              </Button>
            </SoftBox>
            <SoftBox style={{ marginLeft: "auto" }}>
              <Button
                className="vbet-button"
                style={{
                  display: selectedFixture
                    ? selectedFixture.providers.findIndex((item) => item == 2) > -1
                      ? ""
                      : "none"
                    : "none",
                }}
                disabled={!selectedFixture}
                onClick={(e) =>
                  searchVbet(
                    e,
                    selectedFixture
                      ? selectedFixture.fixtureIds[
                          selectedFixture.providers.findIndex((item) => item == 2)
                        ]
                      : null
                  )
                }
              >
                Vbet Results
              </Button>
            </SoftBox>
            <SoftBox>
              <Button
                className="sofa-button"
                disabled={!selectedFixture}
                onClick={(e) => searchSofa(e, selectedFixture)}
              >
                Search SofaScore
              </Button>
            </SoftBox>
            <SoftBox>
              <Button
                disabled={!selectedFixture}
                onClick={(e) =>
                  searchGoogle(
                    e,
                    selectedFixture ? selectedFixture.home + " vs " + selectedFixture.away : null
                  )
                }
              >
                search web
              </Button>
            </SoftBox>
            <SoftBox>
              <Button
                color="warning"
                disabled={!selectedFixture}
                onClick={(e) =>
                  searchBetsApi(
                    e,
                    selectedFixture ? selectedFixture.home + " vs " + selectedFixture.away : null
                  )
                }
              >
                search betsApi
              </Button>
            </SoftBox>
          </div>
        </div>
      </div>
    );
  }

  async function fetchBetsOdds(filters, reset) {
    if (!reset) setDisplayData(false);
    let filtersToSend = { ...filters };
    if (!reset) setFilterToggle(true);
    setLoadingData(true);
    setLoading(true);

    filtersToSend = createfiltersData(filtersToSend);

    if (!filtersToSend || JSON.stringify(filtersToSend) == "{}") return;

    let getOddsEndpoint = `/api/v1/bets/riskManagement`;
    let response = await postData(getOddsEndpoint, filtersToSend, {
      Authorization: getAuthorizationHeader(),
    });
    if (response != null) {
      //console.log(response.data);

      if (response.data.length == 0) {
        setApiresponse("error");
        setApiResponseMsg("There are NO Any Risk Betslips this moment.");
        setNotification(true);
        setLoadingData(false);
        setLoading(false);
        return;
      }

      let dataTable = { ...dataTableData };
      setDataTableData({ columns: [], rows: [] });
      await sleep(1000);

      dataTable.rows = response.data;

      for (let index = 0; index < response.data.length; index++) {
        const row = response.data[index];
        let betslip_eventsType = 0;
        row.tm = new Date().getTime();
        row.odds_multiplier = 1;
        row.inreturn = row.amount;
        row.betslip_status = "won";
        row.betslip_type =
          row.bet_odds && row.bet_odds.length == 1
            ? "(1) single"
            : `(${row.bet_odds.length}) multiple`;
        for (let index = 0; index < row.bet_odds.length; index++) {
          const multi = row.multiplier ? row.multiplier[index] : 1;
          row.odds_multiplier = row.odds_multiplier * multi;

          if (!row.bet_odds_settlements[index]) {
            if (row.betslip_status != "lost") row.betslip_status = "open";
          }
          if (row.bet_odds_settlements[index] == 2) {
            row.betslip_status = "lost";
          }
          betslip_eventsType += row.events_type[index];
        }
        let risks = null;
        for (let j = 0; j < row.risk_uuids.length; j++) {
          const uuid_risk = row.risk_uuids[j];
          if (!uuid_risk.f2) continue;
          if (uuid_risk.f3 == "blocked") row.higherRisk = true;
          if (!risks) risks = {};
          if (!risks[uuid_risk.f2]) {
            risks[uuid_risk.f2] = { status: uuid_risk.f3, count: 0, note: uuid_risk.f4 };
          }
          if (risks[uuid_risk.f2]) {
            risks[uuid_risk.f2].count++;
          }
        }
        row.risks = risks;
        row.betslip_eventsType =
          betslip_eventsType == row.bet_odds.length
            ? "inPlay"
            : betslip_eventsType == 2 * row.bet_odds.length
            ? "preGame"
            : "Both";

        row.odds_multiplier = row.odds_multiplier.toFixed(2);

        row.multiline = {
          columns: [
            { Header: "tm", accessor: "tm", width: "100px" },
            { Header: "Bet odd id", accessor: "uuid", width: "100px", Cell: formatUuid },
            { Header: "Fixture", accessor: "fixture", width: "100px", Cell: fixtureCell },
            { Header: "Market Name", accessor: "name", width: "100px", Cell: formatMarketName },
            { Header: "Odd e", accessor: "e", width: "100px" },
            { Header: "Odd h", accessor: "h", width: "100px" },
            { Header: "Odd o", accessor: "o", width: "100px" },
            { Header: "Outcome", accessor: "outcome_id", width: "80px", Cell: possibleSettlement },
            {
              Header: "Settlement info",
              accessor: "settlement_date",
              width: "100px",
              Cell: renderSettlementInfo,
            },
          ],

          rows: [],
        };
        row.inreturn = (row.inreturn * row.odds_multiplier).toFixed(2);
        row.openSwitch = false;
      }

      currentData = { ...dataTable };
      originalData = { ...dataTable };

      setHiddenColumns(["tm"]);
      setDataTableData(dataTable);
      if (dataTable.rows.length > 0 && !reset) setFilterToggle(false);
      if (!reset) setDisplayData(true);
      setLoadingData(false);
      setLoading(false);
    } else {
    }
  }

  async function fetchSettlementValues() {
    let settlementOutcomesEndPoint = `/api/v1/entities/availableSettlementOutcomes`;
    let response = await getData(settlementOutcomesEndPoint, {
      Authorization: getAuthorizationHeader(),
    });
    if (response != null) {
      //console.log(response.data);
      const noneOption = [{ value: 0, label: "Select..." }];
      const apiOptions = response.data.map((item) => {
        return { value: item.id, label: item.description };
      });

      const allOptions = noneOption.concat(apiOptions);

      settlementOutcomes = allOptions.map((item) => {
        return { value: item.value, label: item.label };
      });
    }
  }

  function formatMarketName({ value, ...rest }) {
    return <div className="cell-double-width">{value}</div>;
  }

  function createfiltersData(filtersToSend) {
    if (
      (filtersToSend["fixture_date_filter"] || filtersToSend["fixture_date_filter"] == 0) &&
      filtersToSend["fixture_date_filter"] != 100
    ) {
      if (filtersToSend["fixture_date_filter"] != -100) {
        let today = new Date();
        today.setHours(0, 0, 0, 0);
        let day = new Date(today);
        day.setHours(0, 0, 0, 0);
        day.setDate(today.getDate() + filtersToSend["fixture_date_filter"]);
        let dt_from = filtersToSend["fixture_date_filter"] >= 0 ? today : day;
        let dt_to = filtersToSend["fixture_date_filter"] >= 0 ? day : today;
        filtersToSend["fixture_from_date"] = new Date(dt_from).toUTCString();
        filtersToSend["fixture_to_date"] = new Date(dt_to).toUTCString();
      } else {
        filtersToSend["fixture_from_date"] = null;
        filtersToSend["fixture_to_date"] = null;
      }
    } else {
      if (filtersToSend["fixture_date_filter"] == 100) {
        if (filtersToSend["fixture_from_date"]) {
          let dt =
            filtersToSend["fixture_from_date"].getUTCFullYear() +
            "-" +
            (filtersToSend["fixture_from_date"].getMonth() + 1 < 10
              ? "0" + (filtersToSend["fixture_from_date"].getMonth() + 1)
              : filtersToSend["fixture_from_date"].getMonth() + 1) +
            "-" +
            (filtersToSend["fixture_from_date"].getDate() < 10
              ? "0" + filtersToSend["fixture_from_date"].getDate()
              : filtersToSend["fixture_from_date"].getDate()) +
            "T00:00:00Z";
          filtersToSend["fixture_from_date"] = new Date(dt).toUTCString();
        }
        if (filtersToSend["fixture_to_date"]) {
          let dt =
            filtersToSend["fixture_to_date"].getUTCFullYear() +
            "-" +
            (filtersToSend["fixture_to_date"].getMonth() + 1 < 10
              ? "0" + (filtersToSend["fixture_to_date"].getMonth() + 1)
              : filtersToSend["fixture_to_date"].getMonth() + 1) +
            "-" +
            (filtersToSend["fixture_to_date"].getDate() < 10
              ? "0" + filtersToSend["fixture_to_date"].getDate()
              : filtersToSend["fixture_to_date"].getDate()) +
            "T00:00:00Z";
          filtersToSend["fixture_to_date"] = new Date(dt).toUTCString();
        }
      }
    }

    if (
      (filtersToSend["bet_date_filter"] || filtersToSend["bet_date_filter"] == 0) &&
      filtersToSend["bet_date_filter"] != 100
    ) {
      if (filtersToSend["bet_date_filter"] != -100) {
        let today = new Date();
        today.setHours(0, 0, 0, 0);
        let day = new Date(today);
        day.setHours(0, 0, 0, 0);
        day.setDate(today.getDate() + filtersToSend["bet_date_filter"]);
        let dt_from = filtersToSend["bet_date_filter"] >= 0 ? today : day;
        let dt_to = filtersToSend["bet_date_filter"] >= 0 ? day : today;
        filtersToSend["bet_from_date"] = new Date(dt_from).toUTCString();
        filtersToSend["bet_to_date"] = new Date(dt_to).toUTCString();
      } else {
        filtersToSend["bet_from_date"] = null;
        filtersToSend["bet_to_date"] = null;
      }
    } else {
      if (filtersToSend["bet_date_filter"] == 100) {
        if (filtersToSend["bet_from_date"]) {
          let dt =
            filtersToSend["bet_from_date"].getUTCFullYear() +
            "-" +
            (filtersToSend["bet_from_date"].getMonth() + 1 < 10
              ? "0" + (filtersToSend["bet_from_date"].getMonth() + 1)
              : filtersToSend["bet_from_date"].getMonth() + 1) +
            "-" +
            (filtersToSend["bet_from_date"].getDate() < 10
              ? "0" + filtersToSend["bet_from_date"].getDate()
              : filtersToSend["bet_from_date"].getDate()) +
            "T00:00:00Z";
          filtersToSend["bet_from_date"] = new Date(dt).toUTCString();
        }
        if (filtersToSend["bet_to_date"]) {
          let dt =
            filtersToSend["bet_to_date"].getUTCFullYear() +
            "-" +
            (filtersToSend["bet_to_date"].getMonth() + 1 < 10
              ? "0" + (filtersToSend["bet_to_date"].getMonth() + 1)
              : filtersToSend["bet_to_date"].getMonth() + 1) +
            "-" +
            (filtersToSend["bet_to_date"].getDate() < 10
              ? "0" + filtersToSend["bet_to_date"].getDate()
              : filtersToSend["bet_to_date"].getDate()) +
            "T00:00:00Z";
          filtersToSend["bet_to_date"] = new Date(dt).toUTCString();
        }
      }
    }

    if (
      (filtersToSend["bet_settled_date_filter"] || filtersToSend["bet_settled_date_filter"] == 0) &&
      filtersToSend["bet_settled_date_filter"] != 100
    ) {
      if (filtersToSend["bet_settled_date_filter"] != -100) {
        let today = new Date();
        today.setHours(0, 0, 0, 0);
        let day = new Date(today);
        day.setHours(0, 0, 0, 0);
        day.setDate(today.getDate() + filtersToSend["bet_settled_date_filter"]);
        let dt_from = filtersToSend["bet_settled_date_filter"] >= 0 ? today : day;
        let dt_to = filtersToSend["bet_settled_date_filter"] >= 0 ? day : today;
        filtersToSend["bet_settled_from_date"] = new Date(dt_from).toUTCString();
        filtersToSend["bet_settled_to_date"] = new Date(dt_to).toUTCString();
      } else {
        filtersToSend["bet_settled_from_date"] = null;
        filtersToSend["bet_settled_to_date"] = null;
      }
    } else {
      if (filtersToSend["bet_settled_date_filter"] == 100) {
        if (filtersToSend["bet_settled_from_date"]) {
          let dt =
            filtersToSend["bet_settled_from_date"].getUTCFullYear() +
            "-" +
            (filtersToSend["bet_settled_from_date"].getMonth() + 1 < 10
              ? "0" + (filtersToSend["bet_settled_from_date"].getMonth() + 1)
              : filtersToSend["bet_settled_from_date"].getMonth() + 1) +
            "-" +
            (filtersToSend["bet_settled_from_date"].getDate() < 10
              ? "0" + filtersToSend["bet_settled_from_date"].getDate()
              : filtersToSend["bet_settled_from_date"].getDate()) +
            " 00:00:00";
          filtersToSend["bet_settled_from_date"] = new Date(dt).toUTCString();
        }
        if (filtersToSend["bet_settled_to_date"]) {
          let dt =
            filtersToSend["bet_settled_to_date"].getUTCFullYear() +
            "-" +
            (filtersToSend["bet_settled_to_date"].getMonth() + 1 < 10
              ? "0" + (filtersToSend["bet_settled_to_date"].getMonth() + 1)
              : filtersToSend["bet_settled_to_date"].getMonth() + 1) +
            "-" +
            (filtersToSend["bet_settled_to_date"].getDate() < 10
              ? "0" + filtersToSend["bet_settled_to_date"].getDate()
              : filtersToSend["bet_settled_to_date"].getDate()) +
            " 00:00:00";
          filtersToSend["bet_settled_to_date"] = new Date(dt).toUTCString();
        }
      }
    }

    delete filtersToSend["bet_date_filter"];
    delete filtersToSend["bet_settled_date_filter"];
    delete filtersToSend["fixture_date_filter"];

    return filtersToSend;
  }

  function formatStatuses({ value, ...rest }) {
    return value ? (
      <HtmlTooltip
        placement="right"
        title={
          <React.Fragment>
            <div style={{}}>
              {value.map((item, index) => {
                return (
                  <div
                    key={rest.row.original.fixtureIds[index] + "-" + item}
                    className={item.replace(/ /g, "_").toLowerCase()}
                  >
                    {item}
                  </div>
                );
              })}
            </div>
          </React.Fragment>
        }
      >
        <div>
          {[...new Set(value)].map((item, index) => {
            return (
              <div
                key={rest.row.original.fixtureIds[index] + "-" + item}
                className={item.replace(/ /g, "_").toLowerCase()}
              >
                {item}
              </div>
            );
          })}
        </div>
      </HtmlTooltip>
    ) : (
      <></>
    );
  }

  function formatDate({ value, ...rest }) {
    let date = new Date(value * 1);
    // let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    // let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
    // let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    // let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();

    // let dateformatted = day + "/" + month + "/" + date.getFullYear() + " " + hours + ":" + minutes;
    let dateformatted = formatUTCTostring(value);
    let timezone = (date.getTimezoneOffset() * -1) / 60;
    timezone = timezone > 0 ? "+" + timezone : timezone;
    let alt_start_date_utc_exist =
      rest.row.original.alt_start_date_utc && value !== rest.row.original.alt_start_date_utc
        ? true
        : false;
    return alt_start_date_utc_exist ? (
      <HtmlTooltip
        placement="right"
        title={
          <React.Fragment>
            <div style={{}}>
              {rest.row.original.start_dates_utc.map((item, index) => {
                let itemFormatted = formatUTCTostring(item);
                return (
                  <div key={rest.row.original.fixtureIds[index] + "-" + item}>{itemFormatted}</div>
                );
              })}
            </div>
          </React.Fragment>
        }
      >
        <div style={{ color: "orange" }}>{dateformatted}*</div>
      </HtmlTooltip>
    ) : (
      dateformatted
    );
  }

  function formatDateStringUTCtoLocale({ value, ...rest }) {
    if (!value) return "-";
    let date = new Date(value);
    let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
    let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();

    let dateformatted = day + "/" + month + "/" + date.getFullYear() + " " + hours + ":" + minutes;
    let timezone = (date.getTimezoneOffset() * -1) / 60;
    timezone = timezone > 0 ? "+" + timezone : timezone;
    let operator =
      rest.column.id == "settlement_date" ? rest.row.original.settled_by_operator : false;

    let betdate = rest.column.id == "created_at" ? true : false;
    let betMoment = null;
    if (betdate) {
      betMoment = "pre";
      if (date.getTime() > rest.row.original.start_date_utc * 1) betMoment = "live";
    }
    return (
      <div className={betMoment ? betMoment + "-bet" : ""}>
        {dateformatted}{" "}
        <Icon style={{ display: operator ? "" : "none", color: "#17c1e8" }}>person_icon</Icon>
      </div>
    );
  }

  function formatSettler({ value, ...rest }) {
    if (!rest.row.original.settlement_date && !value) return "-";

    let settlementType = value.split(": ")[0];
    let settler = value.split(": ")[1];
    return (
      <>
        {settlementType}:
        <div style={{ display: settlementType == "operator" ? "" : "none", color: "#17c1e8" }}>
          {settler ? settler : " - "}
        </div>
        <div
          style={{
            display: settler == "offline" ? "" : "none",
            color: settler == "offline" ? "black" : "green",
          }}
        >
          {settlementType == "operator" ? "" : settler}
        </div>
        <div
          style={{
            display: settler == "online" ? "" : "none",
            color: settler == "offline" ? "black" : "green",
          }}
        >
          {settler}
        </div>
      </>
    );
  }

  function formatSettlementDateDiff({ value, ...rest }) {
    if (!rest.row.original.settlement_date || !value) return "-";

    const diffTime = value;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor((diffTime - diffDays * 1000 * 60 * 60 * 24) / (1000 * 60 * 60));
    const diffMinutes = Math.floor(
      (diffTime - diffDays * 1000 * 60 * 60 * 24 - diffHours * 1000 * 60 * 60) / (1000 * 60)
    );

    return (
      <>
        <div>
          {diffDays < 10 ? "0" + diffDays : diffDays}:{diffHours < 10 ? "0" + diffHours : diffHours}
          :{diffMinutes < 10 ? "0" + diffMinutes : diffMinutes}
        </div>
      </>
    );
  }

  function formatUuid({ value, ...rest }) {
    return (
      <HtmlTooltip
        placement="top"
        title={
          <React.Fragment>
            <div style={{}}>{value.toString()}</div>
          </React.Fragment>
        }
      >
        <div style={{ cursor: "pointer" }} onClick={(e) => handleUUIDCopy(e, value)}>
          <span className="info-icon">{value.toString().substring(1, 10) + "..."}</span>
          <Icon className="info-icon">copy</Icon>
        </div>
      </HtmlTooltip>
    );
  }

  function formatUTCTostring(value) {
    let date = new Date(value * 1);
    let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
    let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();

    let dateformatted = day + "/" + month + "/" + date.getFullYear() + " " + hours + ":" + minutes;
    return dateformatted;
  }

  function possibleSettlement({ value, ...rest }) {
    let outcome_id = value && value != "null" ? value : rest.row.original.operator_outcome_id;
    let risk_for_outcome_id = rest.row.original.risks
      ? rest.row.original.risks
          .filter((r) => r.outcome_id)
          .sort((a, b) => a.created_at < b.created_at)[0]
      : null;

    let original_outcome_id = rest.row.original.outcome_id;
    let outcome_id_tobesend = rest.row.original.outcome_id_tobesend;
    let operator_outcome_id = rest.row.original.operator_outcome_id;

    return rest.row.original.risks ? (
      <div>
        <div>Last Sent Settlement: </div>
        <div
          id="confirmed_holder"
          style={{ display: rest.row.original.confirmed ? "flex" : "none" }}
        >
          <div>
            {original_outcome_id
              ? settlementOutcomes.find((item) => item.value == original_outcome_id)["label"]
              : " - "}
          </div>
          <div style={{ display: rest.row.original.confirmed ? "flex" : "none" }}>
            <div style={{ display: rest.row.original.sent ? "" : "none" }}>
              <HtmlTooltip
                placement="right"
                title={
                  <React.Fragment>
                    <div style={{ display: "flex", flexWrap: "wrap" }}>Confirmed</div>
                  </React.Fragment>
                }
              >
                <Button style={{ margin: "auto", padding: "2px" }}>
                  <Icon style={{ color: "green", opacity: "0.4" }}>verified_icon</Icon>
                </Button>
              </HtmlTooltip>
            </div>
            <div
              style={{
                display: !rest.row.original.sent ? "" : "none",
              }}
            >
              <HtmlTooltip
                placement="right"
                title={
                  <React.Fragment>
                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                      New Settlement Data Exist. You may check Again Settlement
                    </div>
                  </React.Fragment>
                }
              >
                <Button
                  style={{
                    margin: "auto",
                    padding: "2px",
                  }}
                  onClick={(e) =>
                    outcome_id ? openInNewWindow(e, "/settlement/confirmations") : null
                  }
                >
                  <Icon style={{ color: "orange" }}>security_icon</Icon>
                </Button>
              </HtmlTooltip>
            </div>
          </div>
        </div>
        <div
          id="unconfirmed_holder"
          style={{ display: !rest.row.original.confirmed ? "flex" : "none" }}
        >
          <div>
            {outcome_id
              ? settlementOutcomes.find((item) => item.value == outcome_id)["label"]
              : " - "}

            <HtmlTooltip
              placement="right"
              title={
                <React.Fragment>
                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                    {rest.row.original.operator_outcome_id
                      ? "Waiting for Confirmation!"
                      : outcome_id
                      ? "Without Confirmation"
                      : "Waiting for Settlement!"}
                  </div>
                </React.Fragment>
              }
            >
              <Button
                style={{
                  margin: "auto",
                  padding: "2px",
                }}
                onClick={(e) =>
                  outcome_id ? openInNewWindow(e, "/settlement/confirmations") : null
                }
              >
                <Icon
                  style={{ color: rest.row.original.operator_outcome_id ? "orange" : "#cecece" }}
                >
                  {" "}
                  {rest.row.original.operator_outcome_id
                    ? "security_icon"
                    : rest.row.original.outcome_id
                    ? "verified_user_icon"
                    : "border_color_icon"}{" "}
                </Icon>
              </Button>
            </HtmlTooltip>
          </div>
        </div>

        <div style={{ display: "flex" }}>
          <div>
            <SoftSelect
              className="settlement-outcomes"
              style={{ width: "120px !important" }}
              customSmall={true}
              value={
                outcome_id_tobesend
                  ? settlementOutcomes.find((item) => item.value == outcome_id_tobesend)
                  : settlementOutcomes.find((item) => item.value == risk_for_outcome_id.outcome_id)
              }
              options={settlementOutcomes}
              onChange={(value) => handleSettlementOutcomeChange(value, rest.row)}
            ></SoftSelect>
          </div>
          <div>
            <div style={{ display: risk_for_outcome_id.outcome_id ? "" : "none" }}>
              <HtmlTooltip
                placement="right"
                title={
                  <React.Fragment>
                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                      Confirm Settlement. Approve Risk!
                    </div>
                  </React.Fragment>
                }
              >
                <Button
                  style={{
                    margin: "auto",
                    padding: "2px",
                  }}
                >
                  <Icon
                    style={{ color: "green" }}
                    onClick={(e) => (outcome_id ? approveRisk(e, rest.row.original) : null)}
                  >
                    check_outlined_icon
                  </Icon>
                </Button>
              </HtmlTooltip>
            </div>
          </div>
        </div>
      </div>
    ) : rest.row.original.confirmed ? (
      <div style={{ display: "flex" }}>
        <div>
          <SoftSelect
            className="settlement-outcomes"
            style={{ width: "120px !important" }}
            customSmall={true}
            value={
              outcome_id_tobesend
                ? settlementOutcomes.find((item) => item.value == outcome_id_tobesend)
                : settlementOutcomes.find((item) => item.value == outcome_id)
            }
            options={settlementOutcomes}
            isDisabled={true}
          ></SoftSelect>
        </div>
        <div>
          <div>
            <HtmlTooltip
              placement="right"
              title={
                <React.Fragment>
                  <div style={{ display: "flex", flexWrap: "wrap" }}>Confirmed</div>
                </React.Fragment>
              }
            >
              <Button style={{ margin: "auto", padding: "2px" }}>
                <Icon style={{ color: "green", opacity: "0.4" }}>verified_icon</Icon>
              </Button>
            </HtmlTooltip>
          </div>
          <div style={{ display: rest.row.original.sent ? "none" : "" }}>
            <HtmlTooltip
              placement="right"
              title={
                <React.Fragment>
                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                    New Settlement Data Exist. You may check Again Settlement
                  </div>
                </React.Fragment>
              }
            >
              <Button
                style={{
                  margin: "auto",
                  padding: "2px",
                }}
                onClick={(e) =>
                  outcome_id ? openInNewWindow(e, "/settlement/confirmations") : null
                }
              >
                <Icon style={{ color: "orange" }}>security_icon</Icon>
              </Button>
            </HtmlTooltip>
          </div>
        </div>
      </div>
    ) : (
      <div style={{ display: "flex" }}>
        <div>
          <SoftSelect
            className="settlement-outcomes"
            style={{ width: "120px !important" }}
            customSmall={true}
            value={
              outcome_id_tobesend
                ? settlementOutcomes.find((item) => item.value == outcome_id_tobesend)
                : settlementOutcomes.find((item) => item.value == outcome_id)
            }
            options={settlementOutcomes}
            isDisabled={true}
          ></SoftSelect>
        </div>
        <div>
          <HtmlTooltip
            placement="right"
            title={
              <React.Fragment>
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                  {rest.row.original.operator_outcome_id
                    ? "Waiting for Confirmation!"
                    : outcome_id
                    ? "Without Confirmation"
                    : "Waiting for Settlement!"}
                </div>
              </React.Fragment>
            }
          >
            <Button
              style={{
                margin: "auto",
                padding: "2px",
              }}
              onClick={(e) => (outcome_id ? openInNewWindow(e, "/settlement/confirmations") : null)}
            >
              <Icon style={{ color: rest.row.original.operator_outcome_id ? "orange" : "#cecece" }}>
                {" "}
                {rest.row.original.operator_outcome_id
                  ? "security_icon"
                  : rest.row.original.outcome_id
                  ? "verified_user_icon"
                  : "border_color_icon"}{" "}
              </Icon>
            </Button>
          </HtmlTooltip>
        </div>
      </div>
    );
  }

  const handleSettlementOutcomeChange = async (item, row) => {
    setUpdateEnabled(false);
    setHiddenColumns([]);
    setDataTableData({ columns: [], rows: [] });

    if (!currentData.rows) return;
    let betslip_row = currentData.rows.find((r) => r.bet_id == row.original.bet_id);
    let dataRow = betslip_row.multiline.rows.find((mr) => mr.uuid == row.original.uuid);

    if (!dataRow.hasOwnProperty("outcome_id_init")) {
      row.original.outcome_id_init = dataRow.outcome_id;
      dataRow.outcome_id_init = dataRow.outcome_id;
    }
    dataRow.updated = "updated";
    row.original.updated = "updated";
    dataRow.outcome_id_tobesend = item.value;
    setHiddenColumns(["tm"]);

    const settlement = {
      uuid: row.original.uuid,
      outcome_id: item.value,
      event_id: row.original.uni_id ? row.original.uni_id : row.original.event_id,
      provider_id: row.original.provider_id,
      sp: row.original.sp,
    };
    const settlementExist = settlements.find((item) => item.uuid === settlement.uuid);
    if (!settlementExist) {
      if (settlement.outcome_id === 0) settlement.outcome_id = null;
      settlements.push(settlement);
    } else {
      let settlementExistIndex = settlements.findIndex(
        (item) => item.uuid === settlementExist.uuid
      );
      if (settlement.outcome_id === 0) {
        settlement.outcome_id = null;
      } else {
        settlementExist.outcome_id = settlement.outcome_id;
      }
      if (settlementExist.outcome_id == dataRow.outcome_id_init) {
        settlements.splice(settlementExistIndex, 1);
      }
    }
    if (settlements.length > 0) {
      setUpdateEnabled(true);
      setApiresponse("success");
      setApiResponseMsg("There are unsaved Odd Settlements changes.");
      setNotification(true);
      setShowDialog(true);
    } else {
      setApiresponse("error");
      setApiResponseMsg("There are NO unsaved Odd Settlements changes.");
      setNotification(true);
      setShowDialog(false);
    }
    setDataTableData(currentData);
  };

  const handleBetsFilters = (filters, reset) => {
    fetchBetsOdds(filters, reset);
  };

  async function resetData() {
    settlements = [];
    if (applyFilters) setApplyFilters(false);
    if (!applyFilters) setApplyFilters(true);
    setShowDialog(false);
  }

  const sleep = (ms) =>
    new Promise((resolve) => {
      setTimeout(resolve, ms);
    });

  /**
   *
   */
  const handleUUIDCopy = (e, UUID) => {
    //console.log("Copy ApiKey: ", apikey);
    copyToClipboard(UUID);
  };

  const copyToClipboard = (textToCopy) => {
    setApiresponse("success");
    setApiResponseMsg("UUID has been copied to the clipboard!");
    setNotification(true);
    // navigator clipboard api needs a secure context (https)
    if (navigator.clipboard && window.isSecureContext) {
      // navigator clipboard api method'
      return navigator.clipboard.writeText(textToCopy);
    } else {
      // text area method
      let textArea = document.createElement("textarea");
      textArea.value = textToCopy;
      // make the textarea out of viewport
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      return new Promise((res, rej) => {
        // here the magic happens
        document.execCommand("copy") ? res() : rej();
        textArea.remove();
      });
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setNotification(false);
  };

  
  function searchGoogle(e, verd) {
    e.preventDefault();
    var q = verd;
    window.open("http://google.com/search?q=" + q);
  }

  function searchBetsApi(e, verd) {
    e.preventDefault();
    var q = verd;
    window.open("https://betsapi.com/search/?q=" + q.split(" vs ")[0]);
  }

  function searchVbet(e, id) {
    e.preventDefault();
    window.open("https://sport.vbet.am/en/sports/pre-match/results?game=" + id);
  }

  function searchBetfoot(e, id, sport) {
    e.preventDefault();
    if (id && sport) window.open(`https://betfoot.com/live/${sport}/1/${id}`);
  }

  function searchSofa(e, fixture) {
    e.preventDefault();
    let sport = fixture.sport.toLowerCase();
    let home = fixture.home;
    let url = `https://duckduckgo.com/?q=!ducky+inurl:sofascore.com/team/${sport}  ${home}`;
    window.open(url.toString(), "_blank", "noreferrer");
  }

  const informParent = (data) => {
    // console.log("inform Parent", data);
    if (data.key == "search") {
      setExternalSearch(null);
    }
  };

  const handleExpandCollapse = async (data) => {
    // console.log(data);
    let dataTable = { ...dataTableData };

    dataTable.rows = currentData.rows;

    let row_toChange = dataTable.rows.find((r) => r.bet_id == data.value);
    if (row_toChange.multiline.rows.length == 0) {
      setLoading(true);

      // row.multiline.rows = response
      let getOddsEndpoint = `/api/v1/bets/riskManagement/betslip`;
      let response = await postData(
        getOddsEndpoint,
        { bet_id: data.value },
        {
          Authorization: getAuthorizationHeader(),
        }
      );
      if (response != null) {
        let row_toChange = dataTable.rows.find((r) => r.bet_id == data.value);

        for (let index = 0; index < response.data.length; index++) {
          const row = response.data[index];
          let settlement_date = new Date(row.settlement_date);
          let finished_at_date = row.finished_at_utc ? new Date(row.finished_at_utc * 1) : 0;
          let bet_at_date = row.created_at ? new Date(row.created_at) : 0;

          let autoSettlement =
            finished_at_date == 0
              ? row.settlement_date
                ? "online"
                : null
              : settlement_date > finished_at_date
              ? "offline"
              : "online";

          let ask_confirmation_at = row.ask_confirmation_at
            ? new Date(row.ask_confirmation_at)
            : null;

          row.settler = row.settled_by_operator
            ? row.username
              ? "operator: " + row.username
              : "operator"
            : row.settlement_date
            ? "system: " + autoSettlement
            : null;

          let start_date_at = new Date(row.start_date_utc * 1);
          let diffTime = null;

          diffTime = Math.abs(settlement_date.getTime() - bet_at_date.getTime());

          row.diff = diffTime;

          row.conf_diff = ask_confirmation_at
            ? Math.abs(settlement_date.getTime() - ask_confirmation_at.getTime())
            : null;
          row.tm = new Date().getTime();
          row.sortDate = settlement_date.getTime();
          row.payment_percentage = "";
          if (row.risks) {
            if (row.risks.find((r) => r.betslip_status == "blocked")) row.higherRisk = true;
          }
        }

        row_toChange.multiline.rows = response.data;
      }
    }

    setDataTableData({ columns: [], rows: [] });

    sleep(500);
    currentData.rows = dataTable.rows;
    setDataTableData(dataTable);
    setLoading(false);
  };

  const approveRisk = async (e, data) => {
    e.preventDefault();

    Swal.fire({
      title: `Approve Risk Settlement?`,
      html: `You are going to Approve a Risk Settlement. </br></br>Are you Sure?`,
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: "Yes",
      denyButtonText: "Cancel",
      icon: "warning",
      confirmButtonColor: "#87cb16",
      denyButtonColor: "#ff4a55",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const settleOddEndPoint = `/api/v1/bets/settlements/approve`;

        const settlementOutcomesVar = [];

        settlementOutcomesVar.push({
          uuid: data.uuid,
          bet_id: data.bet_id,
          outcome_id: data.outcome_id_tobesend ? data.outcome_id_tobesend : data.risk_outcome_id,
          rule: data.risk_rule,
        });

        const response = await postData(
          settleOddEndPoint,
          { signal: "appove-risks", values: settlementOutcomesVar },
          {
            Authorization: getAuthorizationHeader(),
          }
        );

        resetData();
      }
    });
  };

  const approveRisks = async (e, data) => {
    e.preventDefault();
    if (!data.multiline || !data.multiline.rows || !data.multiline.rows.length > 0) return;
    Swal.fire({
      title: `Approve All Betslip Risk Settlements?`,
      html: `You are going to Approve all the Risk Settlement in this Betslip. </br></br>Are you Sure?`,
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: "Yes",
      denyButtonText: "Cancel",
      icon: "warning",
      confirmButtonColor: "#87cb16",
      denyButtonColor: "#ff4a55",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const settleOddEndPoint = `/api/v1/bets/riskManagement/approve`;

        const settlementOutcomesVar = [];

        for (let index = 0; index < data.multiline.rows.length; index++) {
          const odd = data.multiline.rows[index];
          if (odd.risk_id) {
            settlementOutcomesVar.push({
              uuid: odd.uuid,
              bet_id: odd.bet_id,
              outcome_id: odd.outcome_id_tobesend ? odd.outcome_id_tobesend : odd.risk_outcome_id,
              rule: odd.risk_rule,
            });
          }
        }

        const response = await postData(
          settleOddEndPoint,
          { signal: "appove-risks", values: settlementOutcomesVar },
          {
            Authorization: getAuthorizationHeader(),
          }
        );

        resetData();
      }
    });
  };

  const handleFavorite = async (e, data) => {
    e.preventDefault();

    let favoriteExist = data.risk_uuids.find((r) => r.f2 == 4 && r.f1 == null);
    Swal.fire({
      title: favoriteExist ? `Remove Betslip from Favorites?` : `Add Betslip to Favorites?`,
      html: favoriteExist
        ? `You are going to remove this Betslip from Favorites list. </br></br>Are you Sure?`
        : `You are going to add this Betslip to Favorite list. </br></br>Are you Sure?`,
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: "Yes",
      denyButtonText: "Cancel",
      icon: "warning",
      confirmButtonColor: "#87cb16",
      denyButtonColor: "#ff4a55",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let settleOddEndPoint = `/api/v1/bets/riskManagement/add`;
        if (favoriteExist) {
          settleOddEndPoint = `/api/v1/bets/riskManagement/remove`;
        }

        const risk = {
          uuid: null,
          bet_id: data.bet_id,
          betslip_status: "attention",
          rule: 4,
          note: "",
        };
        const response = await postData(settleOddEndPoint, risk, {
          Authorization: getAuthorizationHeader(),
        });
      }
    });
  };

  async function getSettlementConfig() {
    let getSettlementsConfig = `/api/v1/bets/riskManagement/config`;
    let settlementConfigResult = await getData(getSettlementsConfig, {
      Authorization: getAuthorizationHeader(),
    });
    if (settlementConfigResult != null) {
      setWorkflow(settlementConfigResult.data[0].status);
    }
  }

  async function setSettlementConfig(status) {
    let getSettlementsConfig = `/api/v1/bets/riskManagement/config`;
    let settlementConfigResult = await postData(
      getSettlementsConfig,
      { functionality: "risk_management", status: status },
      {
        Authorization: getAuthorizationHeader(),
      }
    );
    if (settlementConfigResult != null) {
      setWorkflow(settlementConfigResult.data[0].status);
    }
  }

  async function riskSwitchChange(e, risk) {
    e.preventDefault();
    setRiskRuleSelected(risk);

    let allData = { ...originalData };

    allData.rows = risk == 5 ? allData.rows : allData.rows.filter((r) => r.risks && r.risks[risk]);

    setHiddenColumns(["tm"]);
    setDataTableData(allData);
    setLoadingData(false);
    setLoading(false);
  }

  useEffect(() => {
    fetchSettlementValues();
    if (pathname) {
      if (search) {
        let params = [...searchParams.entries()];
        let filters = {};
        for (let index = 0; index < params.length; index++) {
          const param = params[index];
          filters[param[0]] = param[1];
        }

        setPreloadFilters(filters);
        resetData();
        // setApplyFilters(true);
        // setFilterToggle(true);
        if (filters.uni_id) {
          fetchBetsOdds({ fixture_uni_filter: filters.uni_id }, false);
        }
        if (filters.provider_id) {
          fetchBetsOdds({ fixture_id_filter: filters.provider_id }, false);
        }

        if (filters.odd_uuid) {
          fetchBetsOdds({ bet_odd_uuid: filters.odd_uuid }, false);
        }
      }
    }
  }, []);

  useEffect(() => {
    if (providers) {
      //setAvailableProviders(providers);
      availableProviders = providers;
    }
  }, [providers]);

  return (
    <DashboardLayout>
      <DialogBox
        // @ts-ignore
        showDialog={showPrompt}
        confirmNavigation={confirmNavigation}
        cancelNavigation={cancelNavigation}
      />
      <DashboardNavbar />
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        key={"topright"}
        open={notification}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={`${apiResponse}`}
          sx={{ width: "100%" }}
          className={`api-${apiResponse}-notifications`}
        >
          {apiResponseMsg}
        </Alert>
      </Snackbar>
      <SoftBox my={3} sx={{ marginBottom: "0px" }}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={12} sx={{ marginLeft: "0px !important" }}>
            <AdvancedSettlementFilters
              applyFilters={applyFilters}
              settlementOutcomes={settlementOutcomes}
              forceToggle={filterToggle}
              informParent={handleBetsFilters}
              loadingData={loadingData}
              preLoadFilters={preloadFilters}
            ></AdvancedSettlementFilters>
            <SoftBox style={{ display: displayData ? "" : "none" }}>
              <Grid container spacing={0}>
                <Card style={{ width: "100%" }}>
                  <Grid item xs={12} sx={{ paddingTop: "0px", height: "100%" }}>
                    <SoftBox
                      display="flex"
                      justifyContent="space-between"
                      alignItems="flex-start"
                      pt={2}
                      pl={3}
                      pr={3}
                    >
                      <SoftBox lineHeight={1}>
                        <SoftTypography variant="h5" fontWeight="medium">
                          BetSlips
                        </SoftTypography>
                        <SoftTypography variant="button" fontWeight="regular" color="text">
                          Here you can find all <span style={{ color: "#cb0c9f" }}>betslips</span>{" "}
                          have been placed in the Selected Platforms
                        </SoftTypography>
                      </SoftBox>
                    </SoftBox>
                    <SoftBox
                      p={3}
                      sx={{
                        paddingTop: "0px !important",
                        paddingBottom: "0px !important",
                        zIndex: 3,
                      }}
                    >
                      <Grid container>
                        <Grid item xs={6} md={6} style={{ textAlign: "left" }}>
                          <Button
                            className={riskRuleSelected !== 1 ? "switch-unmuted" : "switch-muted"}
                            onClick={(e) => riskSwitchChange(e, 1)}
                          >
                            Closing Betslip
                          </Button>
                          <Button
                            className={riskRuleSelected !== 2 ? "switch-unmuted" : "switch-muted"}
                            onClick={(e) => riskSwitchChange(e, 2)}
                          >
                            Very Fast Settlement
                          </Button>
                          <Button
                            className={riskRuleSelected !== 3 ? "switch-unmuted" : "switch-muted"}
                            onClick={(e) => riskSwitchChange(e, 3)}
                          >
                            User Ban
                          </Button>
                          <Button
                            className={riskRuleSelected !== 4 ? "switch-unmuted" : "switch-muted"}
                            onClick={(e) => riskSwitchChange(e, 4)}
                          >
                            Favorite
                          </Button>
                          <Button
                            className={riskRuleSelected !== 5 ? "switch-unmuted" : "switch-muted"}
                            onClick={(e) => riskSwitchChange(e, 5)}
                          >
                            All
                          </Button>
                        </Grid>
                        <Grid item xs={6} md={6} style={{ textAlign: "right" }}></Grid>
                      </Grid>
                    </SoftBox>
                    <DataTable
                      table={dataTableData}
                      // bottomPadding={26}
                      tableClassName="advanced-riskmanagement-table"
                      entriesPerPage={{
                        defaultValue: 10,
                        entries: [5, 10, 15, 20, 25],
                      }}
                      hiddenColumns={hiddenColumns}
                      // headerClassName="sticky-header"
                      autoResetPageDefault={false}
                      autoResetGlobalFilter={true}
                      autoResetSortBy={true}
                      autoResetSortByDefault={true}
                      canSearch
                      searchValue={externalSearch}
                      openBackDrop={loading}
                      informParent={informParent}
                      refreshEnabled={true}
                      handleExpandCollapse={handleExpandCollapse}
                      showAllResults={false}
                    ></DataTable>
                  </Grid>
                </Card>
              </Grid>
            </SoftBox>
          </Grid>
        </Grid>
      </SoftBox>
    </DashboardLayout>
  );
}

export default AdvancedRisks;
